import { createClient } from '@supabase/supabase-js'
import SimpleLightbox from "simplelightbox";

String.prototype.interpolate = function(params) {
	const names = Object.keys(params);
	const vals = Object.values(params);
	return new Function(...names, `return \`${this}\`;`)(...vals);
}

export class LiveMapGallery extends HTMLElement {
	constructor() {
		super();

		this.supabase = createClient('https://mfszvmepvrddiqschjgc.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1mc3p2bWVwdnJkZGlxc2NoamdjIiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODgxMjc0NTMsImV4cCI6MjAwMzcwMzQ1M30.4bYB2VapvhpsS_QDkT6jYTTqnhitF8GnaJk10CCwt4c')

		console.log('loading images');

		this.loadImages().then((updates) => {

			let images = updates.map((update) => update.meta.images).flat();
			console.log(images);

			for(let i = 0; i < images.length; i++){

				this.addImage(images[i]);

			}

			new SimpleLightbox(this.querySelectorAll('a'));

		});

	}

	loadImages(){

		return new Promise((resolve, reject) => {

			const yesterday = new Date();
			yesterday.setDate(yesterday.getDate() - 1);
			yesterday.setUTCHours(23,59,59,999);

			this.supabase
				.from('location')
				.select('user,longitude,latitude,meta,created_at')
				.eq('meta->update', 'true')
				.neq('meta->images', '[]')
				.lt('created_at', yesterday.toISOString())
				.order('created_at', { ascending: false })
				.limit(21)
				.then(({data, error}) => {

					if(error){
						reject(error);
					}else{
						resolve(data);
					}

				});

		});

	}

	addImage(imageSrc){

		let link = document.createElement("a");
		link.href = `https://mfszvmepvrddiqschjgc.supabase.co/storage/v1/object/public/images/${imageSrc}`;

		let image = document.createElement("img");
		image.src = `https://mfszvmepvrddiqschjgc.supabase.co/storage/v1/object/public/images/${imageSrc}`;

		link.append(image);

		this.append(link);

	}

}

customElements.define('live-map-gallery', LiveMapGallery);
